/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Col, Divider, Row } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import CustomLayout from "../../Core/Layout/CustomLayout";
import CustomDetailsLayout from "../../Core/Layout/CustomDetailsLayout";
import { KPIData, batteryData, voltageData } from "./Data/BatteryDetailData";
import CustomKPI from "../../Core/Components/CustomKpi";
import CustomRoundedImage from "../../Core/Components/CustomRoundedImage";
import { BatteryPackIcon } from "../../Common/Svgs/BatteryIcon";
import { getUserByEmail } from "../../Redux/APIs/systemUsersAPI";
import {
  getBatteryById,
  getBatteryActivities,
} from "../../Redux/APIs/batteriesAPI";
import BatteryBar from "../Trikes/AssociatedBatteries/BatteryBar";
// import BatteryDetailTable from "./phase3/BatteryDetailTable";
import { CHARGER_STATUS } from "../Charger/Data/constants";
import BatteryActivityLog from "./BatteryActivityLog/BatteryActivityLog";

const BatteryDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { currentBattery } = useSelector((state) => state.batteries);
  const { userDetails } = useSelector((state) => state.loggedInUser);

  const batteryId = id || currentBattery?.id;

  const getBatteryColor = (percentage) => {
    if (percentage >= 0 && percentage <= 24) return "bg-alert-red";
    if (percentage >= 25 && percentage <= 50) return "bg-warning";
    return "bg-green";
  };

  // fetch user details (to get permissions on every refresh)
  useEffect(() => {
    dispatch(getUserByEmail({ email: userDetails.email }));
  }, [dispatch]);

  // fetch battery by id if not already in state
  useEffect(() => {
    if (
      id &&
      (!currentBattery?.id || String(currentBattery?.id) !== String(id))
    ) {
      dispatch(getBatteryById({ id }));
    }
  }, [id, dispatch]);

  // fetch battery activities
  useEffect(() => {
    if (batteryId) {
      dispatch(getBatteryActivities({ batteryId }));
    }
  }, [batteryId, dispatch]);

  return (
    <CustomLayout
      pageName="Batteries"
      nestedName={currentBattery?.registrationNo || ""}
    >
      <CustomDetailsLayout
        assetType="batteries"
        KPIBody={
          <div className="bg-background-white">
            <Row gutter={24} className="h-[360px] p-6">
              <Col span={6}>
                <div className="flex flex-col justify-start w-full h-full items-between gap-y-6">
                  {KPIData(currentBattery)?.map((i) => (
                    <CustomKPI
                      key={i.id}
                      title={i.title}
                      value={i.value}
                      image={i.image}
                      background={i.background}
                      count={i.count}
                    />
                  ))}
                </div>
              </Col>
              <Col span={18}>
                <div className="w-full h-full border-[0.5px] border-light-grey rounded-md p-4 flex flex-col justify-between">
                  <div className="flex items-center justify-between">
                    <div className="flex justify-start items-center gap-x-2.5">
                      <CustomRoundedImage
                        color="bg-primary"
                        image={<BatteryPackIcon className="text-kpi-icon" />}
                      />
                      <div className="font-aileron font-normal text-dark-gray text-xs leading-4.5">
                        Battery
                      </div>
                    </div>
                    <div className="flex justify-start items-start gap-x-2.5">
                      <img
                        src={`/assets/icons/details/${
                          currentBattery.chargingStatus ===
                          CHARGER_STATUS.CHARGING
                            ? "charging"
                            : "discharging-grey"
                        }.svg`}
                        alt=""
                      />
                      <div className="font-aileron font-normal text-dark-gray text-xs leading-4.5">
                        {currentBattery.chargingStatus ===
                        CHARGER_STATUS.CHARGING
                          ? "Charging"
                          : "Discharging"}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-start gap-x-5">
                    <div className="flex flex-col">
                      <div className="font-poppins font-semibold text-2xl leading-9 text-center py-2.25 relative z-10">
                        {currentBattery.percentage}%
                      </div>

                      <div className="w-20 h-[198px]">
                        <BatteryBar
                          current={
                            currentBattery.percentage > 0
                              ? currentBattery?.percentage
                              : 1
                          }
                          color={getBatteryColor(currentBattery.percentage)}
                        />
                      </div>
                    </div>
                    <div className="mt-[56px] h-[198px] px-[47px] py-6 bg-background rounded-md w-full">
                      <div className="font-aileron font-semibold text-black text-xs leading-4.5">
                        Specifications
                      </div>
                      <div className="grid grid-cols-5 mt-6">
                        <div className="grid grid-cols-2 gap-x-[42px] gap-y-6 col-span-2">
                          {voltageData(currentBattery)?.map((i) => (
                            <div>
                              <div className="text-10 font-aileron font-normal leading-[15px] text-dark-gray whitespace-nowrap">
                                {i.title}
                              </div>
                              <div className="font-aileron font-semibold text-black text-xs leading-4.5 capitalize">
                                {i.value}
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="flex items-center justify-center w-full h-full">
                          <Divider type="vertical" className="h-24 m-0" />
                        </div>

                        <div className="grid grid-cols-2 gap-x-[42px] gap-y-6 col-span-2">
                          {batteryData(currentBattery)?.map((i) => (
                            <div className="flex flex-col items-start gap-x-[5px]">
                              <div className="text-10 font-aileron font-normal leading-[15px] text-dark-gray whitespace-nowrap">
                                {i.title}
                              </div>

                              <div className="font-aileron font-semibold text-black text-xs leading-4.5">
                                {i.value}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        }
        TableBody={
          <div className="bg-background-white border-y border-light-grey">
            <BatteryActivityLog batteryId={batteryId} />
          </div>
        }
      />
    </CustomLayout>
  );
};
export default BatteryDetails;
